const SurveySingleStyles = {
  root: {
    // Fills the height the page grants it; the step list scrolls inside.
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
};

export default SurveySingleStyles;
